module.exports = __webpack_public_path__ + "img/el.35029ce3.svg";